<template>
  <div class="app-wrapper">
    <router-view v-if="loaded" />
    <!-- Mounted once; internal teleport handles rendering when visible -->
    <session-expired />
  </div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import { captureException } from '@sentry/vue'
import subscriptionService from '@/services/subscription-service'
import appStartService from '@/services/app-start-service'
import { hasValidUserSession, getUserId } from '@/services/identity-client'
import { useIdentityLoginEvent } from '@/composables/identity-login-event'
import SessionExpired from '@/components/auth/session-expired.vue'

export default {
  components: { SessionExpired },
  setup() {
    useIdentityLoginEvent()
  },
  data() {
    return {
      loaded: false,
    }
  },
  async created() {
    if (await hasValidUserSession()) {
      await subscriptionService.syncSubscriptions()
      this.syncAppStart()
    }
    this.loaded = true
  },
  methods: {
    async syncAppStart() {
      try {
        const accountId = await getUserId()
        if (accountId) {
          await appStartService.sync(accountId)
        }
      } catch (e) {
        captureException(e)
      }
    },
  },
}
</script>

<style scoped>
.app-wrapper {
  height: 100%;
}
</style>
